<template>
    <div class="arrowNavigator">
      <a :href="destiny">

      <img :src="mySVG" />
      </a>

    <!-- <a :href="destiny">
       <div class="arrowNavigator-icon arrow"></div>
      <div class="arrowNavigator-icon stick"></div>
    </a> -->
  </div>
</template>
<script>
export default {
  name: "ArrowNavigator",
  props: {
    destiny:{
      type: String,
      required: true
    }
  },
  data(){
    return {
      mySVG: require('../../assets/mb-arrow-btn.svg')
    }
  }




};
</script>